import {
  deleteUnencryptedValue,
  getUnencryptedStringValue,
  saveUnencryptedStringValue,
  UnencryptedStorageKey,
} from "@/hooks/useUnencryptedStorage";

interface WaitingRoomReservation {
  assessmentId: string;
  eventId: string;
  patientId: string;
}

const saveWaitingRoomReservation = (
  reservation: WaitingRoomReservation,
): void => {
  saveUnencryptedStringValue({
    key: UnencryptedStorageKey.WaitingRoomReservation,
    value: JSON.stringify(reservation),
  });
};

const getWaitingRoomReservation = (): null | WaitingRoomReservation => {
  const stored = getUnencryptedStringValue(
    UnencryptedStorageKey.WaitingRoomReservation,
  );
  if (!stored) return null;

  try {
    const parsed = JSON.parse(stored);
    return parsed;
  } catch {
    return null;
  }
};

const clearWaitingRoomReservation = (): void => {
  deleteUnencryptedValue(UnencryptedStorageKey.WaitingRoomReservation);
};

export type { WaitingRoomReservation };
export {
  clearWaitingRoomReservation,
  getWaitingRoomReservation,
  saveWaitingRoomReservation,
};
